import { render } from "./elem-switch.vue?vue&type=template&id=2c6d4470&ts=true"
import script from "./elem-switch.vue?vue&type=script&lang=ts"
export * from "./elem-switch.vue?vue&type=script&lang=ts"

import "./elem-switch.vue?vue&type=style&index=0&id=2c6d4470&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__